// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__kI7a0","lastLink":"HeadPage_lastLink__tQ6dD"};